/**
 * Price Reduction class that is part of the lottery
 */
export class PriceReduction {
  public id: number;
  public '@id': string;
  public name: boolean;
  public limitPerCustomer: number;
  public exclusiveForMembers: boolean;
  public clubAttributes: Array<any>;
  public attributesString: string;
  public checked: boolean;
  public reducedAmount: any;

  constructor(priceReduction: any) {
    this.id = priceReduction.id;
    this['@id'] = priceReduction['@id'];
    this.name = priceReduction.name;
    this.limitPerCustomer = priceReduction.limitPerCustomer;
    this.exclusiveForMembers = priceReduction.exclusiveForMembers;
    this.clubAttributes = priceReduction.clubAttributes;
  }
}
